import template from './activity-editor-ai-markers-tour.html';
import { GoTour, GoTourService } from 'go-modules/go-tour/go-tour.service';
import dayjs from 'dayjs';
import { PlacementEngine } from 'go-modules/go-tour/placement-engine.factory';
import { upgradeNg1Dependency } from '@go-modules/common/ng1-upgrade-factory';

export class ActivityEditorAiMarkersTour {
	public static readonly NG1_INJECTION_NAME = 'activityEditorAiMarkersTour';

	public readonly startDate = dayjs('2024-05-22 8:00:00').toDate();
	public readonly title = 'activity-editor_tour_ai_markers_title' as const;
	public readonly viewTrackKey = 'activity-editor-ai-markers-tour' as const;
	public readonly selector = '.feedback-settings-accordion' as const;
	public tour: GoTour;

	/** @ngInject */
	constructor (
		public goTour: GoTourService,
		private $translate: ng.translate.ITranslateService,
		private PlacementEngine: PlacementEngine
	) {}

	public getTour (): GoTour {
		const placement = this.PlacementEngine.POSITION.RIGHT;
		const title = this.$translate.instant(this.title);
		if (!this.tour) {
			this.tour = this.goTour.defineTour({
				viewTrackKey: this.viewTrackKey,
				constraints: {
					isOnboarding: false,
					tourStartDate: this.startDate,
					maxTourViews: 10
				},
				tourStepClass: this.viewTrackKey,
				steps: [
					{
						tourTitleAriaLabel: title,
						title,
						template,
						selector: this.selector,
						placement
					}
				]
			});
		}

		return this.tour;
	}
}

export const activityEditorAiMarkersTourToken = upgradeNg1Dependency(ActivityEditorAiMarkersTour);
